// extracted by mini-css-extract-plugin
module.exports = {"resourcePage":"ResourcesPage_resourcePage__5tvUK","descriptionWrapper":"ResourcesPage_descriptionWrapper__iZ4nh","banner":"ResourcesPage_banner__yz1i5"};